'use client'

import { useEffect } from 'react'
import { useBreadcrumbsStore } from '../use-breadcrumbs'

const BreadcrumbsSetup = ({ routeName }: { routeName: string }) => {
  const { setName } = useBreadcrumbsStore()
  useEffect(() => {
    setName(routeName)
  }, [routeName, setName])
  return null
}

export default BreadcrumbsSetup
